import { defineMessages } from 'react-intl';

export const messages: {
	betweenNumber: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exactNumber: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	maximumNumber: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minimumNumber: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	wholeNumbersOnly: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	betweenNumber: {
		id: 'proforma-form-renderer.common.utils.validators.number.between-number',
		defaultMessage: 'Must be between {minimum} and {maximum}.',
		description: 'Validation message for field with number between a range.',
	},
	exactNumber: {
		id: 'proforma-form-renderer.common.utils.validators.number.exact-number',
		defaultMessage: 'Must be exactly {number}.',
		description: 'Validation message for field with exact number.',
	},
	maximumNumber: {
		id: 'proforma-form-renderer.common.utils.validators.number.maximum-number',
		defaultMessage: 'Must be less than or equal to {maximum}.',
		description: 'Validation message for field with maximum number.',
	},
	minimumNumber: {
		id: 'proforma-form-renderer.common.utils.validators.number.minimum-number',
		defaultMessage: 'Must be more than or equal to {minimum}.',
		description: 'Validation message for field with minimum number.',
	},
	wholeNumbersOnly: {
		id: 'proforma-form-renderer.common.utils.validators.number.whole-numbers-only',
		defaultMessage: 'Must be a whole number.',
		description: 'Validation message for field with whole numbers only.',
	},
});
